import styled from 'styled-components';
import { motion } from 'framer-motion';
import {Progress, Space} from 'antd';
import {typographyStyles} from '../../../utils/styles';

const StyledBarAmountList = styled.div`
  width: 100%;
`;

const StyledBarAmountListItem = styled(motion.div)`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
`;

const StyledBarAmountListItemSpace = styled(Space)`
  transition: .2s ease-in-out;
  width: 100%;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`;

const StyledBarAmountListItemWrapper = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
`;

const StyledBarAmountListItemName = styled.span`
  ${typographyStyles.footnote.description};

  color: ${props => props.theme.colors.neutral_7};
  flex: 1;
  line-height: 20px;
  letter-spacing: 0;
`;

const StyledBarAmountListItemValue = styled.span`
  ${typographyStyles.footnote.medium};

  color: ${props => props.theme.colors.neutral_10};
  margin-left: 8px;
`;

const StyledBarAmountProgress = styled(Progress)`
  font-size: 10px;
  height: 10px;
  display: flex;
  .ant-progress-outer {
    height: 10px;
  }
`;

export {
  StyledBarAmountList,
  StyledBarAmountListItem,
  StyledBarAmountListItemSpace,
  StyledBarAmountListItemName,
  StyledBarAmountListItemValue,
  StyledBarAmountListItemWrapper,
  StyledBarAmountProgress
}

